import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDoubleRight, faAngleDoubleLeft, faChevronRight, faChevronLeft, faAngleLeft } from '@fortawesome/free-solid-svg-icons'
import TextareaAutosize from '@material-ui/core/TextareaAutosize';
import CircularProgress from '@material-ui/core/CircularProgress';
import { NavLink } from 'react-router-dom';
import Cookies from 'js-cookie';
import ErrorMessage from '../AppLayouts/ErrorMessage';
const axios = require('axios');
const API_URL = process.env.REACT_APP_BASE_URL;

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(2),
    '& textarea': {
      height: '175px !important',
      width: '90%',
      border: '1px solid #ccc !important',
      borderRadius: '5px',
      padding: '10px',
      font: 'inherit',
    }
  },
  addNewStruct: {
    width: '100%',
    '& .MuiPaper-root': {
      width: '100%',
      height: 'auto',
      boxShadow: 'none',
    },
    '& .MuiTextField-root': {
      width: '90%',
    },
    '& input[type="text"]': {
      padding: '10px',
    },
    '& input[type="email"]': {
      padding: '10px',
    },
    '& select#assigned_teams': {
      width: '90%',
      height: '190px',
      padding: '5px',
      fontSize: '15px',
    },
    '& select#available_teams': {
      width: '85%',
      height: '190px',
      padding: '5px',
      fontSize: '15px',
    },
    '& .MuiFormControlLabel-label': {
      fontSize: '14pt',
      color: '#333',
    },
  },
  firstBox: {

  },
  btbBlock: {
    '@media only screen and (max-width: 3500px)': {
      marginTop: '0px',
    },
    '@media only screen and (min-width: 3501px)': {
      marginTop: '25px',
    },
  },
  signInBtn: {
    border: '1px solid rgba(36, 97, 142, 1)',
    color: '#fff',
    background: 'rgba(36, 97, 142, 1)!important',
    '@media only screen and (max-width: 3500px)': {
      width: '150px',
    },
    '@media only screen and (min-width: 3501px)': {
      width: '200px',
      marginLeft: '15px',
    },
    '& .MuiCircularProgress-root': {
      width: '25px !important',
      height: '25px !important',
      color: '#fff'
    }
  },
  cancelBtn: {
    border: '1px solid #333',
    color: '#333',
    background: '#fff!important',
    '@media only screen and (max-width: 3500px)': {
      width: '150px',
    },
    '@media only screen and (min-width: 3501px)': {
      width: '200px',
    },
  },
  nextbtn: {
    textAlign: 'center',
    paddingTop: '10px',
    '& button': {
      width: '35px',
      height: '35px',
      fontSize: '20px',
      border: '1px solid #24618E',
      borderRadius: '3px',
    }
  },
  btnIcon: {

  },
  fieldsetname: {
    width: 'auto',
    border: '1px solid rgba(0, 167, 93, 1)',
    padding: '10px',
    // box-shadow: 1px 4px 5px 1px #ccc;
    borderRadius: '5px',
    '& p': {
      margin: '0',
    }
  },
  maincontent: {
    width: '100%',
  }

}));

const AddNewTeam = (props) => {
  const classes = useStyles();
  const [privileges, setPrivileges] = React.useState([]);
  const [teamName, setTeamName] = React.useState('');
  const [description, setDescription] = React.useState('');
  const [teamValues, setTeamValues] = React.useState({
    team_name: "",
    description: "",
  });
  const [errPopUp, setErrPopUp] = React.useState(false);
  const [errMsg, setErrMsg] = React.useState(null);
  const [errMsgType, setErrMsgType] = React.useState('error');
  const [loader, setLoader] = React.useState(false);

  const ShowErrPopUP = () => {
    setErrPopUp(false)
  };

  const handleChange = (event) => {
    let newArray = [...privileges, event.target.value];
    if (privileges.includes(event.target.value)) {
      newArray = newArray.filter(id => id !== event.target.value);
    }
    setPrivileges(
      newArray
    );
  };

  const validateForm = async e => { // add team form validations
    setErrMsg(null);
    e.preventDefault();
    if (teamValues.team_name == '') {
      setErrMsg('Team name required.');
      setErrPopUp(true);
    } else if (teamValues.description == '') {
      setErrMsg('Description required.');
      setErrPopUp(true)
    } else if (privileges.length == 0) {
      setErrMsg('Select atleast one privilege.');
      setErrPopUp(true)
    } else {
      AddTeamAPI();
    }
  }

  const formHandleChange = name => event => {
    if (name == 'team_name') {
      setTeamName(event.target.value);
    } else if (name == 'description') {
      setDescription(event.target.value);
    }
    setTeamValues({ ...teamValues, [name]: event.target.value });
  }

  const clearTeamForm = () => {
    setTeamName('');
    setDescription('');
    setPrivileges([]);
    setTeamValues({
      team_name: "",
      description: "",
    });
  }

  const AddTeamAPI = () => { // API call to add new team
    setLoader(true);
    let data = { ...teamValues, ...{ team_privileges: privileges } };
    try {
      axios({
        method: 'post',
        data: { ...data },
        headers: {
          'payload': Cookies.get('payload'),
          'agencyid': sessionStorage.getItem('agency_id')
        },
        url: API_URL + '/api/v1/user/addteam',
      })
        .then(async function (response) {
          if (response.status && response.status == '200') {
            props.teamTabBack();
          } else {
            setErrMsgType('error')
            setErrMsg('Something went wrong.');
            setErrPopUp(true)
            setLoader(false);
          }
          setLoader(false);
        })
        .catch(function (error) {
          if (error.response) {
            setErrMsgType('error')
            setErrMsg(error.response.data.message);
            setErrPopUp(true)
            setLoader(false);
          } else {
            setErrMsgType('error')
            setErrMsg('Something went wrong.');
            setErrPopUp(true)
            setLoader(false);
          }
        })
    } catch (error) {
      console.error(error);
      setLoader(false);
    }
  }


  return (
    <React.Fragment>
      <div className={classes.addNewStruct}>
        <div className={classes.root}>
          <p style={{ marginBottom: '10px', marginTop: '0' }}><NavLink to="#" style={{ color: '#24618E' }} onClick={props.teamTabBack}><FontAwesomeIcon icon={faAngleLeft} />&nbsp;Return to Teams Listing</NavLink></p>
          <h5 style={{ margin: '0', paddingLeft: '12px' }}>Add New Team</h5>
          <div className='errMsg' style={{ width: '28.4%', marginLeft: '18px' }}>
            {errMsg ? <div className={classes.errMsgPassword}><ErrorMessage message={errMsg} visible={ShowErrPopUP} show={errPopUp} msgType={errMsgType} /> </div> : null}
          </div>

          <Grid container spacing={3} className={classes.maincontent}>
            <Grid item xs={10}>
              <form className={classes.rootForm} noValidate autoComplete="off" data-testid='team_details_from' onSubmit={e => validateForm(e)}>
                <Grid container spacing={3}>
                  <Grid item xs={5}>
                    <Grid xs={12} item>
                      <Paper className={classes.paper} >
                        <TextField id="name" data-testid='team_name' className={classes.formInput} placeholder="Name *" type="text" variant="outlined" required onChange={formHandleChange('team_name')} value={teamName} />
                      </Paper>
                    </Grid>
                    <Grid xs={12} item>
                      <Paper className={classes.paper} >
                        <TextareaAutosize aria-label="minimum height" rowsMin={3} placeholder="Description" data-testid='description' onChange={formHandleChange('description')} value={description} />
                      </Paper>
                    </Grid>
                  </Grid>
                  <Grid item xs={7}>
                    <Paper className={classes.paper} >
                      <fieldset className={classes.fieldsetname}>
                        <legend>Privileges</legend>
                        <p><FormControlLabel
                          value="Users in this team can view detailed station data"
                          control={<Checkbox color="primary" onChange={handleChange} value='1' />}
                          label="Users in this team can view detailed station data"
                          labelPlacement="end"
                          id="team_station_data"

                        /></p>
                        <p><FormControlLabel
                          value="Users in this team can manage users"
                          control={<Checkbox color="primary" onChange={handleChange} value='2' />}
                          label="Users in this team can manage users"
                          labelPlacement="end"
                          id="team_can_manage_users"
                        /></p>
                        <p><FormControlLabel
                          value="Users in this team can import data files"
                          control={<Checkbox color="primary" onChange={handleChange} value='3' />}
                          label="Users in this team can import data files"
                          labelPlacement="end"
                          id="can_import_data_files"
                        /></p>
                        <p><FormControlLabel
                          value="Users in this team can approve data imports"
                          control={<Checkbox color="primary" onChange={handleChange} value='4' />}
                          label="Users in this team can approve data imports"
                          labelPlacement="end"
                          id="can_approve_data_imports"
                        /></p>
                        <p><FormControlLabel
                          value="Users in this team can delete data files"
                          control={<Checkbox color="primary" onChange={handleChange} value='5' />}
                          label="Users in this team can delete data files"
                          labelPlacement="end"
                          id="can_delete_data_files"
                        /></p>

                      </fieldset>
                    </Paper>
                  </Grid>
                </Grid>
                <Grid item xs={6}>
                  <Paper className={classes.paper}>
                    <div className={classes.btbBlock}>
                      <Button type="reset" variant="outlined" id="cancel_btn" data-testid="cancel_btn" className={classes.cancelBtn} onClick={() => { clearTeamForm() }}>
                        Cancel</Button>&nbsp;&nbsp;
                       <Button type="submit" variant="outlined" id="save_btn" data-testid="save_btn" className={classes.signInBtn}>
                        {loader == true ?
                          <CircularProgress />
                          :
                          'Add Team'
                        }</Button>
                    </div>
                  </Paper>
                </Grid>
              </form>
            </Grid>
            <Grid item xs={4}>

            </Grid>
          </Grid>
        </div>

      </div>
    </React.Fragment>
  );
}

export default AddNewTeam;